<template>
  <v-container>
    <v-alert color="success" v-if="alertSuccess">Data byla uložena.</v-alert>
    <p class="display-1">Zvolte bránu</p>
    <v-radio-group v-model="gate" row>
      <v-radio label="GoPay" value="goPay"></v-radio>
    </v-radio-group>
    <hr><br>
    <v-form v-if="gate === 'goPay'" v-model="goPayFormValid">
      <v-row cols="12"
             class="justify-center">
        <v-col
          cols="6">
          <p class="display-1">Nastavení GoPay</p>
          <v-text-field
            label="GoID"
            v-model="goPay.goId"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="ClientID"
            v-model="goPay.clientId"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="ClientSecret"
            v-model="goPay.clientSecret"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-btn
            color="primary"
            class="float-right"
            @click="saveGoPay"
            :disabled="!goPayFormValid || wait"
          >
            Uložit
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row v-else-if="gate === 'fioBanka'"></v-row>
  </v-container>
</template>

<script>
import rules from '../../../mixins/rules'
export default {
  name: 'PaymentGates',
  mixins: [rules],
  data () {
    return {
      alertSuccess: false,
      gate: 'goPay',
      goPay: {
        goId: '',
        clientId: '',
        clientSecret: '',
        testMode: true
      },
      wait: false,
      initialGoPay: {},
      goPayFormValid: true
    }
  },
  methods: {
    saveGoPay () {
      this.wait = true
      this.$http.post('/admin/gopay', this.keysToSnakeCase(this.goPay)).then(response => {
        this.alertSuccess = true
        setTimeout(() => {
          this.alertSuccess = false
        }, 3000)
        this.getGoPay()
        this.wait = false
      }).catch(() => {
        alert('Neplatné údaje.')
        this.goPay = this.initialGoPay
        this.wait = false
      })
    },
    getGoPay () {
      this.$http.get('/admin/gopay').then(response => {
        this.goPay = this.keysToCamelCase(response.data)
        this.initialGoPay = Object.assign({}, this.goPay)
      })
    }
  },
  created () {
    this.getGoPay()
  }
}
</script>

<style scoped>

</style>
